export default {
    url: '',
    template: '<courses-application-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/application/list/index.js